import { render, staticRenderFns } from "./TrustedShops.vue?vue&type=template&id=1db83767&"
import script from "./TrustedShops.vue?vue&type=script&lang=js&"
export * from "./TrustedShops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports